import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { api } from "@/lib/api";

export const formatCOP = (v) => `$${new Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(v)} COP`;

export const dims = (p, orientation) => {
  const a = Math.max(p.width_cm, p.height_cm), b = Math.min(p.width_cm, p.height_cm);
  return orientation === "vertical" ? { w: b, h: a } : { w: a, h: b };
};

export const nativeOrientation = (p) => (p.width_cm >= p.height_cm ? "horizontal" : "vertical");

export const useCatalog = () =>
  useQuery({ queryKey: ["catalog"], queryFn: () => api.get("/catalog").then((r) => r.data), staleTime: 0, refetchOnWindowFocus: true });

export const waLink = (phone, text = "Hola LUMINA STUDIO, quiero información sobre las láminas magnéticas flotantes.") =>
  `https://wa.me/${(phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const igLink = (handle) => `https://www.instagram.com/${(handle || "").replace(/^@/, "")}/`;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, noindex = false }) => {
  useEffect(() => {
    document.title = title;
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); }
    setMeta("property", "og:title", title);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = `${window.location.origin}${window.location.pathname}`;
  }, [title, description, noindex]);
};

const LIVE = { staleTime: 0, refetchOnWindowFocus: true };

export const useSiteMediaState = () => {
  const { data = [], isFetched } = useQuery({ queryKey: ["site-media"], queryFn: () => api.get("/site-media").then((r) => r.data), ...LIVE });
  return { media: Object.fromEntries(data.map((m) => [m.key, m])), ready: isFetched };
};

export const useSiteMedia = () => useSiteMediaState().media;

export const useHeroText = () =>
  useQuery({ queryKey: ["hero-text"], queryFn: () => api.get("/site-content/hero").then((r) => r.data), ...LIVE }).data;
